import { number, object, string } from "yup";

export interface SubscriptionCouponResource {
  id: number;
  coupon: {
    code: string;
  };
}

const couponSchema = object({
  code: string().required(),
});

export const subscriptionCouponResourceSchema = object({
  id: number().required(),
  coupon: couponSchema.required(),
});
